module.exports = __webpack_public_path__ + "img/4_43.8a9faeec.png";